export async function generateExpirationDateFromBatch(
  batch,
  nameProduct,
  shelfLife,
  { fromProductionHandover = false } = {},
  // 2731591
) {
  if (fromProductionHandover)
    return expirationDateFromProductionBatch(batch, shelfLife);
  if (
    !fromProductionHandover &&
    (nameProduct.toUpperCase().includes('GROLSCH') ||
      nameProduct.toUpperCase().includes('PILSNER') ||
      nameProduct.toUpperCase().includes('ASAHI') ||
      nameProduct.toUpperCase().includes('PERONI'))
  ) {
    const expirationDate = new Date();

    // return expirationDate.toLocaleDateString();
    return expirationDate;
  }
  const productionYear = await determineYearFromLastDigit(batch.charAt(2));
  const productionDay = await parseInt(batch.substring(3, 6));
  const productionDate = new Date(productionYear, 0);

  productionDate.setDate(productionDay);
  productionDate.setDate(productionDate.getDate() + shelfLife);
  // return productionDate.toLocaleDateString();
  return productionDate;
}

function determineYearFromLastDigit(lastDigit) {
  if (lastDigit >= 0 && lastDigit <= 9) {
    const currentYear = new Date().getFullYear();
    const lastYearDigit = currentYear % 10;
    const yearDifference = lastDigit - lastYearDigit;
    const determinedYear = currentYear + yearDifference;

    return determinedYear;
  } else {
    throw new Error('Ostatnia cyfra musi być w zakresie od 0 do 9.');
  }
}

export async function generateProductionDateFromBatch(
  batch,
  // 2731591
) {
  const productionYear = await determineYearFromLastDigit(batch.charAt(2));
  const productionDay = await parseInt(batch.substring(3, 6));
  const productionDate = new Date(productionYear, 0);

  productionDate.setDate(productionDay);
  // productionDate.setDate(productionDate.getDate() + shelfLife);
  // return productionDate.toLocaleDateString();
  return productionDate;
}

// Zlecenie z przekazania produkcji potwierdza zastosowanie krajowego formatu partii,
// niezależnie od marki produktu. Nie zmieniamy reguł dla ręcznie wpisanego importu.
export function expirationDateFromProductionBatch(batch, shelfLife) {
  if (!/^\d{7}$/.test(batch) || !Number.isFinite(shelfLife) || shelfLife <= 0) {
    throw new Error('Nieprawidłowa partia lub okres przydatności.');
  }
  const year = determineYearFromLastDigit(batch.charAt(2));
  const day = Number(batch.substring(3, 6));
  const daysInYear = new Date(year, 1, 29).getMonth() === 1 ? 366 : 365;
  if (day < 1 || day > daysInYear)
    throw new Error('Nieprawidłowy dzień produkcji w partii.');
  return new Date(year, 0, day + shelfLife);
}
